/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user: NonNullable<unknown> }} User_LabelInputs */

const en_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`User: ${i?.user}`)
};

const fr_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utilisateur : ${i?.user}`)
};

const de_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Benutzer: ${i?.user}`)
};

const it_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utente: ${i?.user}`)
};

const ru_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пользователь: ${i?.user}`)
};

const es_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usuario: ${i?.user}`)
};

const zh_cn2_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用户：${i?.user}`)
};

const ja_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ユーザー: ${i?.user}`)
};

const hi_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता: ${i?.user}`)
};

const pt_pt2_user_label = /** @type {(inputs: User_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usuário: ${i?.user}`)
};

/**
* | output |
* | --- |
* | "User: {user}" |
*
* @param {User_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const user_label = /** @type {((inputs: User_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_user_label(inputs)
	if (locale === "de") return de_user_label(inputs)
	if (locale === "it") return it_user_label(inputs)
	if (locale === "ru") return ru_user_label(inputs)
	if (locale === "es") return es_user_label(inputs)
	if (locale === "zh-CN") return zh_cn2_user_label(inputs)
	if (locale === "ja") return ja_user_label(inputs)
	if (locale === "hi") return hi_user_label(inputs)
	if (locale === "pt-PT") return pt_pt2_user_label(inputs)
	return en_user_label(inputs)
});